const env = window.env

export const API_ROOT = env.VITE_API_ROOT
export const SIGNALR_HUB_URL = env.VITE_SIGNALR_HUB_URL

export const AUTH_URL = env.VITE_AUTH_URL
export const AUTH_CLIENT_ID = env.VITE_AUTH_CLIENT_ID
export const AUTH_REDIRECT_URI = env.VITE_AUTH_REDIRECT_URI
export const AUTH_SCOPE = env.VITE_AUTH_SCOPE
export const AUTH_REALM = env.VITE_AUTH_REALM
